import { MutationTree } from 'vuex';
import { MiniTableState } from './types';

export const mutations: MutationTree<MiniTableState> = {};
